<template>
  <TextInput v-bind="{ ...$attrs, ...props }" :type="inputType">
    <template #append-inner>
      <Btn :size="BtnSize.SM" icon @click="changeInputType">
        <Icon :icon="inputType === InputType.PASSWORD ? EyeSvg : EyeSlashSvg" />
      </Btn>
    </template>
  </TextInput>
</template>

<script setup lang="ts">
import { ref } from 'vue';
import { TextInput } from '@/components/inputs/text-input';
import { Icon } from '@/components/icon';
import { Btn, BtnSize } from '@/components/btn';
import EyeSvg from '@/assets/icons/eye.svg?component';
import EyeSlashSvg from '@/assets/icons/eye-slash.svg?component';
import { RuleExpression } from 'vee-validate';

type Props = {
  id?: string;
  modelValue: string;
  placeholder?: string;

  rules?: RuleExpression<unknown>;
  hideDetails?: boolean | 'auto';

  label?: string;
  disabled?: boolean;
};
const props = defineProps<Props>();

enum InputType {
  PASSWORD = 'password',
  TEXT = 'text',
}

const inputType = ref<InputType>(InputType.PASSWORD);

const changeInputType = () => {
  inputType.value =
    inputType.value === InputType.PASSWORD
      ? InputType.TEXT
      : InputType.PASSWORD;
};
</script>
